import clsx from 'clsx';
import { ComponentPropsWithoutRef, forwardRef } from 'react';

export type ModalFormFooterProps = ComponentPropsWithoutRef<'div'>;

export const createModalFormFooter = () => {
	const ModalFormFooter = forwardRef<HTMLElement, ModalFormFooterProps>(
		({ className, children, ...props }, ref) => (
			<footer
				ref={ref}
				className={clsx('modal-form-footer', className)}
				{...props}
			>
				{children}
			</footer>
		),
	);

	return ModalFormFooter;
};
